// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FRLQR","hint":"styles_hint__SVq9B","cards":"styles_cards__DZ+BA","action":"styles_action__xbO2E"};